import HambrugareMeny from './HamburgareMeny';
export { toggle } from './hamburgareActions';
export default HambrugareMeny;
